<template>
  <div class="">
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('widgets')">Widgets</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span>
      {{ form.title }}
    </h1>
    <trashed-message v-if="widget.deleted_at" class="mb-6" @restore="restore">
      Dieses Widget wurde gelöscht.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.title" :error="form.errors.title" class="pr-6 pb-8 w-full lg:w-1/2" label="Titel" />

          <quill-editor
            ref="myQuillEditor"
            v-model="form.content"
            :error="form.errors.content"
            class="pr-6 pb-8 mb-8 w-full lg:w-full"
            label="Inhalt"
          />

          <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept="image/*" label="Foto" />
          <img v-if="widget.photo" class="block ml-4" :src="widget.photo" />
          <select-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-1/2" label="Status">
            <option value="draft" selected>Entwurf</option>
            <option value="publish">Veröffentlichen</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!widget.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy"
          >
            Löschen
          </button>
          <button v-if="widget.deleted_at" class="text-green-600 hover:underline" tabindex="-1" type="button"
                  @click="restore"
          >
            Wiederherstellen
          </button>
          <loading-button :loading="form.processing" class="btn-green ml-auto" type="submit">
            Aktualisieren
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileInput from '@/Shared/FileInput'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  metaInfo() {
    return {
      title: `${this.form.title}`,
    }
  },
  components: {
    quillEditor,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    FileInput,
  },
  layout: Layout,
  props: {
    widget: Object,
    tinyMceApiKey: String,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        title: this.widget.title,
        content: this.widget.content,
        status: this.widget.status,
        photo: this.widget.photo_path,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(this.route('widgets.update', this.widget.id).url(), {
        onSuccess: () => this.form.reset('photo'),
      })
    },
    destroy() {
      if (confirm('Möchten Sie dieses Widget wirklich löschen?')) {
        this.$inertia.delete(this.route('widgets.destroy', this.widget.id))
      }
    },
    restore() {
      if (confirm('Möchten Sie dieses Widget wirklich wiederherstellen?')) {
        this.$inertia.put(this.route('widgets.restore', this.widget.id))
      }
    },
  },
}
</script>
